// extracted by mini-css-extract-plugin
export default {"container_dollars":"dollarsAnimation_container_dollars__4HWDF","block_dollars":"dollarsAnimation_block_dollars__dPA6z","dollar_svg":"dollarsAnimation_dollar_svg__Mezva"};